import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { NAV_LINKS, LEGAL_LINKS, LOGO_URL } from "@/lib/motion";

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative bg-[#0A0A0A] border-t border-white/10 overflow-hidden">
      <div className="mx-auto max-w-[1600px] px-6 lg:px-12 py-20 lg:py-28">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-6">
            <p className="text-xs uppercase tracking-[0.25em] text-[#C5A059] mb-6">
              Structurer les projets · Éclairer les décisions · Créer une valeur durable
            </p>
            <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl font-light leading-[0.95] text-[#F9F6F0]">
              Échangeons sur
              <br />
              <span className="italic text-[#C5A059]">vos enjeux.</span>
            </h2>
            <p className="mt-8 max-w-xl text-[#F9F6F0]/60 font-light leading-relaxed">
              Chaque projet présente des défis spécifiques. Que vous soyez une institution publique,
              un investisseur, une entreprise ou un porteur de projet, nous serons heureux d'échanger
              avec vous afin d'explorer les solutions les plus adaptées à vos objectifs.
            </p>
            <Link
              to="/contact"
              data-testid="footer-cta"
              className="group inline-flex items-center gap-3 mt-10 text-sm uppercase tracking-[0.2em] text-[#F9F6F0] border-b border-[#C5A059] pb-2"
            >
              Prendre contact
              <ArrowUpRight size={18} className="text-[#C5A059] transition-transform duration-500 group-hover:translate-x-1 group-hover:-translate-y-1" />
            </Link>
          </div>

          <div className="lg:col-span-3 lg:col-start-8">
            <p className="text-xs uppercase tracking-[0.25em] text-[#F9F6F0]/40 mb-6">Navigation</p>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="link-underline text-[#F9F6F0]/70 hover:text-[#F9F6F0] transition-colors">Accueil</Link>
              </li>
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="link-underline text-[#F9F6F0]/70 hover:text-[#F9F6F0] transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <p className="text-xs uppercase tracking-[0.25em] text-[#F9F6F0]/40 mb-6">Contact</p>
            <p className="text-[#F9F6F0]/70 leading-relaxed">
              66 avenue des Champs-Élysées
              <br />
              75008 Paris
              <br />
              <a href="tel:+33618470960" className="hover:text-[#C5A059] transition-colors">06 18 47 09 60</a>
              <br />
              <a href="mailto:leonie.honban@herusaxiom.com" className="hover:text-[#C5A059] transition-colors whitespace-nowrap text-sm">leonie.honban@herusaxiom.com</a>
            </p>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-white/10 flex flex-col gap-6">
          <div className="flex flex-wrap gap-x-8 gap-y-3">
            {LEGAL_LINKS.map((l) => (
              <Link key={l.to} to={l.to} data-testid={`legal-${l.to.replace("/", "")}`} className="text-xs uppercase tracking-[0.15em] text-[#F9F6F0]/40 hover:text-[#C5A059] transition-colors">
                {l.label}
              </Link>
            ))}
          </div>
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
            <img src={LOGO_URL} alt="HERUS Axiom" className="h-16 w-auto opacity-80" />
            <span className="text-xs uppercase tracking-[0.2em] text-[#F9F6F0]/40">
              © {new Date().getFullYear()} HERUS Axiom — Tous droits réservés
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
